export const RouteLiterals = {
  ROOT: '/',
  LANDING: 'landing',
  DASHBOARD: 'dashboard',
  SELECT_PROFILE: 'select-profile',
  LOGIN: 'login',
  REQUEST_RESPONSE: 'request-response',
  REQUESTS: 'requests',
  CONSENT_PREFERENCES: 'consent-preferences',
  PURPOSES: 'purposes',
  VIEW_REQUEST: 'view-request',
  ID: ':id',
  AUTHENTICATE: 'authenticate',
  NOTIFICATION_SETTINGS: 'notification-settings',
  ACCOUNT: 'account',
  ASSESSMENT_RESPONDER_FORM: '/risk-management/assessment/:token',
  ASSESSMENT_RESPONDER_FORM_ROUTE: '/risk-management/assessment/',
  ASSESSMENT_RESPONDER_FORM_LEGACY: '/consent-risk-management/v1/assessment/:token',
  ASSESSMENT_RESPONDER_FORM_LEGACY_ROUTE: '/consent-risk-management/v1/assessment/',
  FEEDBACK: 'feedback/signed',
};

export const RouteIDs = {
  ROOT: 'root',
  LANDING: 'landing',
  DASHBOARD: 'dashboard',
  SELECT_PROFILE: 'select-profile',
  LOGIN: 'login',
  ID: ':id',
  REQUEST_RESPONSE: 'request-response',
  REQUESTS: 'requests',
  CONSENT_PREFERENCES: 'consent-preferences',
  VIEW_PURPOSE_DETAILS: 'view-purpose-details',
  VIEW_REQUEST: 'view-request',
  AUTHENTICATE: 'authenticate',
  NOTIFICATION_SETTINGS: 'notification-settings',
  VIEW_NOTIFICATION_SETTINGS: 'view-notification-settings',
  ACCOUNT: 'account',
  ASSESSMENT_RESPONDER_FORM: 'assessment-responder-form',
  ASSESSMENT_RESPONDER_FORM_LEGACY: 'assessment-responder-form-legacy',
  FEEDBACK: 'feedback',
};
